// Copyright text placeholder, Warner Bros. Discovery, Inc.

/**
 *  WARNING:
 *  This file is auto-generated. Do not edit manually. Any changes made to this
 *  file will be overwritten the next time it is generated. If you need to make
 *  changes, please modify the source files and re-generate this file.
 */

import { BaseEvent, IVersionedEvent } from '../../../core';

/**
 *
 *
 * version 1.0
 * @public
 */
interface IHeartbeatV1Payload {}

/**
 * ApplicationHeartbeatV1 event
 * An event emitted periodically to indicating the client and application are active.
 * @public
 */
export class ApplicationHeartbeatV1 extends BaseEvent<IHeartbeatV1Payload> {
  /** unique event type **/
  public readonly eventType: string = 'beam.events.application.heartbeat_1.0';

  /**
   * overrides the default _build method to add default values for fields
   * @param payload - The payload for this event.
   * @returns IVersionedEvent<IHeartbeatV1Payload>
   */
  protected override _build(payload: IHeartbeatV1Payload): IVersionedEvent<IHeartbeatV1Payload> {
    return super._build({
      ...payload
    });
  }
}

export type { IHeartbeatV1Payload as IApplicationHeartbeatV1Payload };
